import { isly } from "isly";
export var Hour;
(function (Hour) {
    var _a;
    Hour.values = [
        "00",
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
    ];
    _a = isly
        .string("value", ...Hour.values)
        .rename("isoly.Time.Hour")
        .bind(), Hour.type = _a.type, Hour.is = _a.is, Hour.flawed = _a.flawed;
    let Numeric;
    (function (Numeric) {
        var _a;
        Numeric.values = [
            0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
        ];
        _a = isly
            .number("value", ...Numeric.values)
            .rename("isoly.Time.Hour.Numeric")
            .bind(), Numeric.type = _a.type, Numeric.is = _a.is, Numeric.flawed = _a.flawed;
    })(Numeric = Hour.Numeric || (Hour.Numeric = {}));
    function parse(value) {
        return Hour.Numeric.type.get(Number.parseInt(value));
    }
    Hour.parse = parse;
    function create(value) {
        return Hour.type.get(value.toString().padStart(2, "0"));
    }
    Hour.create = create;
})(Hour || (Hour = {}));
//# sourceMappingURL=Hour.js.map